<div class="metabase-card">
  <iframe
    class="metabase-iframe"
    [src]="safeUrl"
    loading="lazy"
    referrerpolicy="no-referrer"
  ></iframe>
</div>